import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ArrowUpRight } from 'lucide-react';
import { COMPANY, SERVICES, CATEGORIES } from '../../mock';

export default function Footer() {
  return (
    <footer className="bg-slate-100 border-t border-slate-200 pt-16 pb-8">
      <div className="egea-container">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="h-9 w-9 bg-[#f5a524] flex items-center justify-center">
                <span className="font-display font-black text-slate-900 text-lg">E</span>
              </div>
              <div className="font-display font-bold text-[17px] text-slate-900">
                {COMPANY.name}<span className="text-[#f5a524]">.</span>
                <span className="text-slate-400 font-medium">{COMPANY.brandLine}</span>
              </div>
            </div>
            <p className="text-[14px] text-slate-500 leading-relaxed max-w-[260px]">
              Producător român de schele și confecții metalice certificate UE din 1995.
            </p>
          </div>

          <div>
            <h4 className="section-eyebrow mb-4">Categorii</h4>
            <ul className="space-y-2.5">
              {CATEGORIES.map((c) => (
                <li key={c.key}>
                  <Link to={`/produse?categorie=${encodeURIComponent(c.key)}`} className="text-[14px] text-slate-600 hover:text-[#d97706] transition-colors">
                    {c.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="section-eyebrow mb-4">Companie</h4>
            <ul className="space-y-2.5">
              <li><Link to="/proiecte" className="text-[14px] text-slate-600 hover:text-[#d97706] transition-colors">Proiecte</Link></li>
              <li><a href="/#despre" className="text-[14px] text-slate-600 hover:text-[#d97706] transition-colors">Despre noi</a></li>
              <li><a href="/#servicii" className="text-[14px] text-slate-600 hover:text-[#d97706] transition-colors">Servicii</a></li>
              <li><a href="/#contact" className="text-[14px] text-slate-600 hover:text-[#d97706] transition-colors">Contact</a></li>
              <li><Link to="/admin/login" className="text-[14px] text-slate-400 hover:text-[#d97706] transition-colors">Admin</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="section-eyebrow mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href={COMPANY.phoneHref} className="flex items-center gap-2.5 text-[14px] text-slate-600 hover:text-slate-900 transition-colors">
                  <Phone size={15} className="text-[#f5a524]" /> {COMPANY.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2.5 text-[14px] text-slate-600 hover:text-slate-900 transition-colors">
                  <Mail size={15} className="text-[#f5a524]" /> {COMPANY.email}
                </a>
              </li>
              <li className="flex items-center gap-2.5 text-[14px] text-slate-600">
                <MapPin size={15} className="text-[#f5a524]" /> {COMPANY.location}
              </li>
            </ul>
            <a
              href={`https://wa.me/${COMPANY.whatsapp}`}
              target="_blank"
              rel="noreferrer"
              className="btn-ghost px-4 py-2.5 text-[13px] uppercase tracking-wide mt-5 inline-flex items-center gap-1.5"
            >
              WhatsApp <ArrowUpRight size={14} />
            </a>
          </div>
        </div>

        <div className="section-line my-10" />
        <div className="flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[13px] text-slate-400">
            © {new Date().getFullYear()} {COMPANY.name} Invest. Toate drepturile rezervate.
          </p>
          <p className="text-[13px] text-slate-400">Fabrică · {COMPANY.location} · {COMPANY.since}</p>
        </div>
      </div>
    </footer>
  );
}
